










































































































































































































































import { VueEditor } from 'vue2-editor';
import { Component, Mixins, Watch } from 'vue-property-decorator';

import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { SLUG_HREF_TYPES, LIST_PAGE_TYPES } from '@resclick/data-access';
import { LANGUAGE_MENU } from '@/constants/language-menu.constant';
import { i18n } from '@/i18n';

@Component({
  components: {
    VueEditor,
  },
})
export default class UserRoleModal extends Mixins(ModalMixin) {
  form!: CrsForm<'web', 'createSlug' | 'updateSlug'>;
  activeTab = 'en-US';
  address = {
    country: 0,
    province: 0,
    district: 0,
  };
  searchInput = '';
  propertySearchOptions: any[] = [];

  hotels = [];

  findHotel(id: string) {
    // @ts-ignore
    return this.hotels.find((h: any) => h.id === id)?.name;
  }

  removeHotel(hotelId: string) {
    // @ts-ignore
    this.form.fields.hotelsList = this.form.fields.hotelsList.filter((id: string) => id !== hotelId);
  }

  @Watch('searchInput')
  handleSearchInput(val: string) {
    if (val) {
      // @ts-ignore
      this.form.fields.hotelsList.push(val);
      this.form.fields.hotelsList = [...(new Set(this.form.fields.hotelsList) as any)];
    }
  }

  @Watch('mode', { immediate: true })
  switchForm(mode: 'create' | 'update') {
    this.form = this.$crsForm('web', mode === 'create' ? 'createSlug' : 'updateSlug', {
      isActive: false,
      href: '',
      type: SLUG_HREF_TYPES.STATIC,
      content: {
        'en-US': '',
        'tr-TR': '',
        'fr-FR': '',
      },
      footer: false,
      hotelsList: [],
      hotel: '',
      country: 0,
      province: 0,
      district: 0,
      title: {
        'en-US': '',
        'tr-TR': '',
        'fr-FR': '',
      },
      listPageType: LIST_PAGE_TYPES.SPESIFIC_LIST,
    });
  }

  handleInput(val: string) {
    this.form.fields.href = this.form.fields.href.toLowerCase();
    if (val.includes('/')) this.form.fields.href = this.form.fields.href.replace('/', '-');
    if (val.includes(' ')) this.form.fields.href = this.form.fields.href.replace(' ', '-');
    if (val.includes('ü')) this.form.fields.href = this.form.fields.href.replace('ü', 'u');
    if (val.includes('ö')) this.form.fields.href = this.form.fields.href.replace('ö', 'o');
    if (val.includes('ç')) this.form.fields.href = this.form.fields.href.replace('ç', 'c');
    if (val.includes('ş')) this.form.fields.href = this.form.fields.href.replace('ş', 's');
    if (val.includes('ğ')) this.form.fields.href = this.form.fields.href.replace('ğ', 'g');
    if (val.includes('İ')) this.form.fields.href = this.form.fields.href.replace('İ', 'i');
    if (val.includes('ı')) this.form.fields.href = this.form.fields.href.replace('ı', 'i');
    if (val.includes('I')) this.form.fields.href = this.form.fields.href.replace('I', 'i');
  }

  get availableLanguages() {
    return LANGUAGE_MENU.map((item) => {
      return {
        label: item.name,
        code: item.iso,
        flag: item.img,
      };
    });
  }

  get addressValidators() {
    return {
      country: {
        hasError: this.form.hasError('address.country'),
        message: this.form.getError('address.country'),
      },
      province: {
        hasError: this.form.hasError('address.province'),
        message: this.form.getError('address.province'),
      },
      district: {
        hasError: this.form.hasError('address.district'),
        message: this.form.getError('address.district'),
      },
    };
  }

  get slugTypeOptions() {
    return [
      { label: i18n.t('GENERAL.STATIC'), value: SLUG_HREF_TYPES.STATIC },
      { label: i18n.t('GENERAL.HOTELS_LIST'), value: SLUG_HREF_TYPES.HOTELS_LIST },
      { label: i18n.t('GENERAL.HOTEL'), value: SLUG_HREF_TYPES.HOTEL },
    ];
  }

  get listPageTypeOptions() {
    return [
      { label: i18n.t('GENERAL.SPESIFIC_LIST'), value: LIST_PAGE_TYPES.SPESIFIC_LIST },
      { label: i18n.t('GENERAL.PLACE'), value: LIST_PAGE_TYPES.PLACE },
    ];
  }

  async getForm() {
    const response = await compass.do('web', 'findOneSlug', { params: { id: this.id }, lang: 'all' });

    this.address = {
      // @ts-ignore
      country: response.data.country,
      // @ts-ignore
      province: response.data.province,
      // @ts-ignore
      district: response.data.district,
    };

    return response;
  }

  filterFn(val: string, update: any, abort: any) {
    if (val.length < 3) {
      abort();
      return;
    }

    compass
      .do('autoCompletions', 'findProperties', {
        query: { key: val },
      })
      .then((res) => res.data)
      .then((data) => {
        update(
          () => {
            if (val === '') {
              this.propertySearchOptions = [];
            } else {
              this.propertySearchOptions = data.map((item) => {
                // @ts-ignore
                this.hotels.push(item);
                return {
                  label: item.name,
                  value: item.id,
                  type: item.type,
                };
              });
            }
          },
          (ref: any) => {
            if (val !== '' && ref.options.length > 0) {
              ref.setOptionIndex(-1); // reset optionIndex in case there is something selected
              ref.moveOptionSelection(1, true); // focus the first selectable option and do not update the input-value
            }
          },
        );
      });
  }

  abortFilterFn() {
    return;
  }

  onSubmitOverride({ id }: { id: string }) {
    if (this.form.fields.type === SLUG_HREF_TYPES.HOTELS_LIST) {
      if (this.form.fields.listPageType === LIST_PAGE_TYPES.SPESIFIC_LIST) {
        this.form.fields.country = 0;
        this.form.fields.province = 0;
        this.form.fields.district = 0;
      } else {
        this.form.fields.hotelsList = [];
        this.form.fields.country = this.address.country;
        this.form.fields.province = this.address.province;
        this.form.fields.district = this.address.district;
      }

      this.form.fields.hotel = '';
      this.form.fields.footer = false;
      this.form.fields.content = {
        'en-US': '',
        'tr-TR': '',
        'fr-FR': '',
      };
    } else {
      this.form.fields.hotelsList = [];
      this.form.fields.country = 0;
      this.form.fields.province = 0;
      this.form.fields.district = 0;
    }

    // @ts-ignore
    this.onSubmit({ id });
  }
}
